import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateEventItem($companyId: ID!, $attributes: EventItemAttributes!) {
    createEventItem(companyId: $companyId, attributes: $attributes) {
      eventItem {
        id
        ...CreatedEventItem
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedEventItem on EventItem {
    id
    eventStage { id }
    notes
    quantity
    discount
    item {
      ...on AssetType {
        id
        name
        images { id url }
      }
      ...on Package {
        id
        name
        images { id url }
      }
      ...on RowItem {
        id
        name
        images { id url }
      }
      ...on Vehicle {
        id
        name
        images { id url }
      }
    }
  }
`
